import { configureStore } from '@reduxjs/toolkit';
import catalogReducer from './reducers/catalogReducer';
import mediaReducer from './reducers/mediaReducer';
import similarReducer from './reducers/similarReducer';
import reviewReducer from './reducers/reviewReducer';
import searchReducer from './reducers/searchReducer';
import suggestionReducer from './reducers/suggestionReducer';
import authReducer from './reducers/authReducer';
import genreReducer from './reducers/genreReducer';
import activityReducer from './reducers/activityReducer';
import topReducer from './reducers/topReducer';
import adReducer from './reducers/adReducer';

export const store = configureStore({
  reducer: {
    catalog: catalogReducer,
    genres: genreReducer,
    media: mediaReducer,
    similar: similarReducer,
    reviews: reviewReducer,
    search: searchReducer,
    suggestion: suggestionReducer,
    auth: authReducer,
    activity: activityReducer,
    top: topReducer,
    ads: adReducer,
  },
});
